import React from 'react';
import CobuStack from '../layout/CobuStack';
import CobuText from './CobuText';
import { GetThemeValueForKey } from '@tamagui/core';
import { getAvatarColor } from '../../utils/avatarColors';

interface TextAvatarProps {
  /**
   * The user's name to generate initials from
   */
  name?: string;
  /**
   * The user's UUID to determine avatar color
   */
  uuid: string;
  /**
   * Size of the avatar (defaults to $10)
   */
  size?: GetThemeValueForKey<"height" | "width">;
  /**
   * Font size for the initials (defaults to $3)
   */
  fontSize?: GetThemeValueForKey<"fontSize">;
}

export default function CobuTextAvatar({ 
  name, 
  uuid, 
  size = '$10', 
  fontSize = '$3' 
}: TextAvatarProps) {
  // Generate color based on UUID
  const { backgroundColor, color } = getAvatarColor(uuid);

  // Generate initials from name
  const initials = (name ?? '')
    .split(' ')
    .slice(0, 2)
    .map((namepart: string) => namepart.charAt(0).toUpperCase())
    .join('');

  return (
    <CobuStack
      w={size}
      h={size}
      br="$full"
      ai="center"
      jc="center"
      style={{ backgroundColor }}
    >
      <CobuText
        variant="body"
        fos={fontSize}
        fow="bold"
        style={{ color }}
      >
        {initials}
      </CobuText>
    </CobuStack>
  );
}